import { render, staticRenderFns } from "./ProjectPostingItemPublishModal.vue?vue&type=template&id=46afd803&scoped=true"
import script from "./ProjectPostingItemPublishModal.vue?vue&type=script&lang=js"
export * from "./ProjectPostingItemPublishModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46afd803",
  null
  
)

export default component.exports